import React, { Component } from 'react';

import researchApi from '/src/apis/researchApi';
import AmplitudeHelperClass from '/src/utilities/amplitudeHelper';
import { ar, en } from "/src/utilities/constants/dictionary";
import { getItemWebUrl } from '/src/utilities/helpers';



const amplitudeHelper = new AmplitudeHelperClass();

class PromotedReportWidget extends Component {

    /*
     * Promoted Report widget
     * a custom widget used to promote a report on a news / research single page
     * 
     * example usage: <div id="widget-research-actions" data-report="reportId" data-promo-title="Promo section title" data-report-promo="Sample text promoting the report or linking it to the article content"></div>
     */

    constructor(props) {
        super(props);
        this.state = {
            renderWidget: false,
        };
    }

    componentDidMount() {
        this.getResearchDetails();
    }

    getResearchDetails = async () => {
        const { reportId } = this.props;
        const fields = ['lang', 'id', 'code', 'name']; // only call required fields for widget
        const data = await researchApi.getResearchDetails(reportId, fields);
        if (data !== 404) {
            this.setState({ renderWidget: true, data: data.researchData });
        }
    }

    amplitudeTrack = () => {
        const { data } = this.state;
        const event = 'Clicked Button in Promoted Report Widget';
        amplitudeHelper.trackEvent(event, {
            report_name: data.name,
        });
    }

    renderWidget = () => {
        const { data } = this.state;
        const { promoText, promoTitle, baseLanguage } = this.props;
        const reportUrl = getItemWebUrl('research', data.id, data.code);

        // widget title + text
        // baseLanguage = lang of the page displayed on, not the report being promoted
        const dictionary = (data.lang == "ar" || baseLanguage == "ar") ? ar() : en();
        const widgetText = (promoText) ? <div className="promo-text">{promoText}</div> : null;

        return (
            <div className="db-box widget-box research-body-widget promoted-report-widget" dir={(data.lang == "ar") ? "rtl" : ""} >
                <div className="db-header">
                    <div>{promoTitle ? promoTitle : 'Want to learn more about this data point?'}</div>
                </div>
                <div className="widget-form">
                    {widgetText}
                    <a className="btn btn-main" href={`/${reportUrl}`} onClick={() => this.amplitudeTrack()}>
                        {dictionary.accessReport}
                    </a>
                </div>
            </div>
        )
    }

    render() {
        const { renderWidget } = this.state;
        if (renderWidget) {
            return (
                <div className="content-body-widget-text d-block">
                    {this.renderWidget()}
                </div>
            )
        } else {
            return (null);
        }
    }

}

export default PromotedReportWidget;
